import { Controller } from "@hotwired/stimulus";
import { Tab } from "bootstrap";

export default class PostTabsController extends Controller {
  connect() {
    this.handleTabShown = this.handleTabShown.bind(this);

    this.element.addEventListener(
      "shown.bs.tab",
      this.handleTabShown
    );

    this.restoreActiveTab();
  }

  disconnect() {
    this.element.removeEventListener(
      "shown.bs.tab",
      this.handleTabShown
    );
  }

  handleTabShown(event) {
    const target = event.target.dataset.bsTarget;
    const url = new URL(window.location.href);

    if (target === "#heroes-tab") {
      url.searchParams.set("tab", "heroes");
    } else if (target === "#strip-tab") {
      url.searchParams.delete("tab");
    }

    history.replaceState(history.state, "", url);
  }

  restoreActiveTab() {
    const params = new URLSearchParams(window.location.search);
    const activeTab = params.get("tab");

    const target =
      activeTab === "heroes" ? "#heroes-tab" : "#strip-tab";

    const tabButton = this.element.querySelector(
      `[data-bs-target="${target}"]`
    );

    if (tabButton) {
      Tab.getOrCreateInstance(tabButton).show();
    }
  }
}
